// Generated by scripts/make-pictures.mjs from public/images. Don't edit by hand:
// change the pictures and run `pnpm pictures` instead. See pictures.ts.
import type { PictureData } from "./pictures";

export const ALPHABET =
	"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!#$%&()*+,-./:;<=>?@[]^_{|}~";

export const PICTURE_DATA: PictureData[] = [
	{
		name: "heart",
		file: "heart-16.png",
		width: 16,
		height: 16,
		colors: ["2ec4e6ff", "24182cff", "e04050ff", "ffd0d8ff", "a02838ff"],
		pixels:
			"0000000000000000000000000000000000011100001110000012221001222100012332211222221001232222222222100122222222222210012222222222241000122222222241000001222222241000000012222241000000000122241000000000001241000000000000011000000000000000000000000000000000000000",
	},
	{
		name: "cherries",
		file: "cherries-16.png",
		width: 16,
		height: 16,
		colors: [
			"3e9cf0ff",
			"86d04eff",
			"4c9a3cff",
			"24182cff",
			"d8304aff",
			"ffb8c4ff",
			"8e1c30ff",
		],
		pixels:
			"0000000000000000000000000110000000000000211100000000000202000000000000200020000000000200000200000000200000002000000200000000020000333000000333000345430000345430034443000034443003644300003644300033300000033300000000000000000000000000000000000000000000000000",
	},
	{
		name: "planet",
		file: "planet-16.png",
		width: 16,
		height: 16,
		colors: [
			"e264e8ff",
			"fff6b0ff",
			"2b1d3aff",
			"ffd28aff",
			"f0a04bff",
			"c06a35ff",
			"7fb2e0ff",
			"4a78b0ff",
			"c8e6ffff",
			"8a4a2aff",
		],
		pixels:
			"0000000000010000010000000000000000000222222001000000233334420000000233334444222000233344444456720023344444555672002344444555562002644444555662002764444558899200276668888599920002225555599920000010255999920000000002222220001000000000000000000000000000000000",
	},
	{
		name: "fish",
		file: "fish-16.png",
		width: 16,
		height: 16,
		colors: [
			"d6409fff",
			"24182cff",
			"f5c84aff",
			"3d8fe0ff",
			"ffffffff",
			"8cc8ffff",
			"2a5ea8ff",
		],
		pixels:
			"0000000000000000000000000000000000000001111000000000001222210000110011333333110013101333333333101331333333341310133333333331133113333333333333311331555333333361131015555333361011001155556661000000011666611000000000122100000000000001100000000000000000000000",
	},
	{
		name: "flower",
		file: "flower-16.png",
		width: 16,
		height: 16,
		colors: [
			"3e9cf0ff",
			"24182cff",
			"ffb6d6ff",
			"f06aa8ff",
			"ffd23cff",
			"f0a020ff",
			"3f9a48ff",
			"7ccf6aff",
		],
		pixels:
			"0000000000000000000000111100000000000123321000000011113333111100012331144113321001333144451333100133314455133310001111155111110000000133331000000000012332100000000000166100000000110001610011000177100161017710001771016117710000017711617710000000011161100000",
	},
	{
		name: "cat",
		file: "cat-16.png",
		width: 16,
		height: 16,
		colors: [
			"3e9cf0ff",
			"24182cff",
			"f08a3cff",
			"f4a0b8ff",
			"46b06aff",
			"ffc489ff",
			"fff4e6ff",
		],
		pixels:
			"0000000000000000001000000000010001210000000012100132100000012310012221111112221001222222222222100122222222222210012244222244221001224122224122100122222222222210015522233222551001555221122555100015555555555100000116666661100000000111111000000000000000000000",
	},
	{
		name: "rocket",
		file: "rocket-16.png",
		width: 16,
		height: 16,
		colors: [
			"12a594ff",
			"24182cff",
			"e8443cff",
			"d8dee8ff",
			"9aa6b8ff",
			"5ec8f0ff",
			"ffb030ff",
			"ffe26aff",
		],
		pixels:
			"0000000110000000000000122100000000000122221000000000013333100000000013333441000000001311114100000000131551410000000013155141000000001311114100000000133333410000000121333341210000122133334122100012211111112210001110167610111000000017671000000000000161000000",
	},
	{
		name: "house",
		file: "house-16.png",
		width: 16,
		height: 16,
		colors: [
			"12a594ff",
			"24182cff",
			"c8443aff",
			"8e2c26ff",
			"e8cfa0ff",
			"7cc8f0ff",
			"7a4a2aff",
			"c2a070ff",
		],
		pixels:
			"0000000000000000000000011000000000000012210000000000012222100000000012222221000000012222222210000013333333333100000144444444100000014111444410000001415141111000000141114166100000014444416610000001777771661000000111111111100000000000000000000000000000000000",
	},
	{
		name: "potion",
		file: "potion-16.png",
		width: 16,
		height: 16,
		colors: [
			"3fcf8eff",
			"24182cff",
			"b07a4aff",
			"c8dce8ff",
			"ffffffff",
			"d2a8ffff",
			"a066e0ff",
			"6a3aa8ff",
		],
		pixels:
			"0000001111000000000000122100000000000012210000000000011111100000000000133100000000000013310000000000013334100000000013333341000000015555555510000016566666666100001646666666610000166666666671000016666666667100000176666667100000001111111100000000000000000000",
	},
	{
		name: "tree",
		file: "tree-16.png",
		width: 16,
		height: 16,
		colors: [
			"f4f6faff",
			"24182cff",
			"86d65cff",
			"3fa04aff",
			"e84848ff",
			"2a6e34ff",
			"b07c48ff",
			"8a5a32ff",
		],
		pixels:
			"0000001111000000000011223311000000012223333310000012233334333100001233333333310001233433333355100133333333433510013333333333551000133343333551000015333333555100000115555551100000000116711000000000001671000000000000167100000000000166771000000000111111110000",
	},
	{
		name: "sun",
		file: "sun-16.png",
		width: 16,
		height: 16,
		colors: ["3e9cf0ff", "24182cff", "f59a24ff", "ffd23cff", "fff2a0ff"],
		pixels:
			"0000000110000000000000122100000000100001100001000121000000001210001000111100010000000133331000000000134433310000121013433331012112101333332101210000133332210000000001332210000000100011110001000121000000001210001000011000010000000012210000000000000110000000",
	},
	{
		name: "mushroom",
		file: "mushroom-24.png",
		width: 24,
		height: 24,
		colors: [
			"2ec4e6ff",
			"22172bff",
			"f05a6aff",
			"d8304aff",
			"fff4f4ff",
			"a8202cff",
			"8e1c30ff",
			"c8b28cff",
			"efe2c4ff",
			"4c9a3cff",
		],
		pixels:
			"000000000000000000000000000000001111111100000000000000112223333311000000000011222333344333110000000122244333444433351000001222444433344333555100012223444433333344555510012233344344333444455510122344333344335444455551133344333344355544555551166666666666666666666651166666666666666666666610011111117788888811111100000000017788888810000000000000017788888810000000000000017788888810000000000000017788888810000000000000017788888810000000000011117788888811110000001199997788888899991100019999997788888899999910019999999999999999999910001199999999999999991100000011111111111111110000",
	},
	{
		name: "cupcake",
		file: "cupcake-24.png",
		width: 24,
		height: 24,
		colors: [
			"12a594ff",
			"22172bff",
			"ff8090ff",
			"d8304aff",
			"a8202cff",
			"fffaf0ff",
			"fff1d6ff",
			"e8d0a8ff",
			"f76b15ff",
			"86d04eff",
			"5ec8f0ff",
			"ffd23cff",
			"a374dcff",
			"e07aa8ff",
			"f2a8c8ff",
		],
		pixels:
			"00000000001111000000000000000000012334100000000000000000013344100000000000000000113444110000000000000001554444661000000000000015566666667100000000000015666666677100000000000156668867777610000000001556666677777771000000015566666777799777100000015666aa6666777777100000016666666677777777100000016666666bb7777cc7100000001666667777777771000000001d667777777777e10000000001eed777777edd100000000001eeddeeddeedd100000000001eeddeeddeedd100000000001eeddeeddeedd100000000001eeddeeddeedd1000000000001eddeeddeed10000000000001eddeeddeed1000000000000011111111110000000000000000000000000000000",
	},
	{
		name: "castle",
		file: "castle-32.png",
		width: 32,
		height: 32,
		colors: [
			"f5c518ff",
			"22172bff",
			"e8443cff",
			"7a4a2aff",
			"b7bfccff",
			"8f9aacff",
			"3d2a40ff",
			"4c9a3cff",
		],
		pixels:
			"0000012221100000000000000122211000001322222100000000000013222221000013222110000000000000132221100000132110000000000000001321100000001310000000000000000013100000001013101000000000000010131010000141434141000000000001414341410001414341410000000000014143414100015444445410000000000144445444100144445444100000000001445444441001444454441000000000014454444410014444544411100110011144544444100144544444144114411441544444541001445444441441144114415444445410014456644454444454444454466454100154466454444454444454444664441001544664544444544444544446644410015446645444445444445444466444100144445444445444445444445444441001444454444453333334444454444410014444544444533333344444544444100144544444543333333344544444541001445444445433333333445444445410014454444454333333334454444454100154444454443333333354444454441001544444544433333333544444544410015444445444333333335444445444100144445444443333333344445444441011444454444433333333444454444411777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777",
	},
	{
		name: "sailboat",
		file: "sailboat-32.png",
		width: 32,
		height: 32,
		colors: [
			"8fd14fff",
			"22172bff",
			"7a4a2aff",
			"fff2a0ff",
			"ffffffff",
			"f4f6faff",
			"d8dee8ff",
			"e86a50ff",
			"c8443aff",
			"8fd0ffff",
			"3e9cf0ff",
			"2e7cd0ff",
		],
		pixels:
			"0000000000000000000000000000000000000000000000011000000011110000000000000000001221000001333310000000000000000012210000133333310000000000000001422100013333333310000000000000145221000133333333100000000000001552210001333333331000000000000155522410013333333310000000000001555224100013333331000000000000155552244100013333100000000000015555522441000011110000000000000155555224451000000000000000000015555552245510000000000000000000155555522555510000000000000000015555555225555510000000000000001555555562255555100000000000000015555556622555555100000000000001555556666225555551000000000000015555666662255556661000000000001555566666622555666610000000000155566666666225566666610000000001111111111112211111111111100000177777777777777777777777777100000188888888888888888888888810000000188888888888888888888881000011100188888888888888888888100011999111199998889999988899999111999111999991119999911199999111999911aaaaa111aaaaa111aaaa1111aaaa11aaaaa111aaaa1111aaaa1111aaaa1111bb1111bbbb1111bbbb1111bbbb111bbb1101bbbb1101bbbb111bbbbb111bbbbb",
	},
	{
		name: "robot",
		file: "robot-32.png",
		width: 32,
		height: 32,
		colors: [
			"e264e8ff",
			"22172bff",
			"e8443cff",
			"b7bfccff",
			"e2e8f0ff",
			"7c8aa0ff",
			"5ec8f0ff",
			"ffffffff",
			"3d4560ff",
			"86d04eff",
			"ffd23cff",
		],
		pixels:
			"00000000000000122100000000000000000000000000012222100000000000000000000000000122221000000000000000000000000000122100000000000000000000000000001331000000000000000000000111111113311111111000000000000014444333333333333331000000000000144433333333333333310000000000111433333333333333335111000000015553336666333366665555551000000155533367663333676655555510000001555333666633336666555555100000015553336666333366665555551000000155533333333335555555555510000000111333338888888855555111000000000013333333555555555551000000000000133333355555555555510000000000000111111111111111111000000000001111144333333333333111110000000133331433333333333331333310000001333313338888888833313333100000013333133388888888335133331000000011111333898aa828355111110000000000001333888888885551000000000000000013338888888855510000000000000000133333333555555100000000000000001333333355555551000000000000000013333355555555510000000000000000011555111155511000000000000000000015551001555100000000000000000000155510015551000000000000000000000111000011100000000000",
	},
	{
		name: "owl",
		file: "owl-32.png",
		width: 32,
		height: 32,
		colors: [
			"2ec4e6ff",
			"22172bff",
			"8a5a32ff",
			"b07c48ff",
			"d4a06aff",
			"fff6e0ff",
			"ffd23cff",
			"efe2c4ff",
			"f5a020ff",
			"c8a878ff",
		],
		pixels:
			"0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000010000000000012100000111111000011210000000000122111113333331111222100000000001222244333333333322221000000000001225555533335555522100000000000012555555533555555521000000000000125566655335566655210000000000014556111655556111655210000000000135561116555561116552100000000001335566655775566655221000000000133355555557755555552221000000001333355555788755555222210000000013333377977887977722222100000000133333777777777777222221000000001333337777777777772222210000000013333277977977977722222100000000013322777777777777222210000000000132227777777777772222100000000001222277977977977722221000000000001222777777777777222100000000000001222777777777722210000000111111111222977977972221111111112222222222288277772882222222222222222222222882222228822222222222222222222222222222222222222222221111111111111111111111111111111100000000000000000000000000000000",
	},
	{
		name: "sunset",
		file: "sunset-48.png",
		width: 48,
		height: 48,
		colors: [
			"8b93ffff",
			"b8a0f0ff",
			"3d2a40ff",
			"f2a8c8ff",
			"4c6a40ff",
			"ff8f7aff",
			"5a7a4aff",
			"ffd23cff",
			"ffa64dff",
			"ffd27aff",
			"c86a9aff",
			"7a6ad0ff",
			"4f5fb0ff",
		],
		pixels:
			"000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000111111111111111111111111111111111111211111111111111111111111111111111111111111111122111111111111111111111111111111111111111111112111111111111111111111111111111111111111111111221111111121111111111111111111111111111111111111111111112211111111333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333443333333555555555555555555555555555555555555554444455555555555566555555555555555555555555555544444444555555556666655555555555555555555555554444444444445555666666665555555555555555555555544444444444444566666666666655555555777777555555444444444444444666666666666668888877777777778884444444444444444666666666666666888777777777777844444444444444444666666666666666687777777777777744444444444444444666666666666666667777777777777744444444444444444666666666666666666777777777777444444444444444444666666666666666666677777777777444444444444444444666666666666666666677777777774444444444444444444666666666666666666667777777774444444444444444444666666666666666666666777777774444444444444444444666666666666666666666677777744444444444444444444555555555555555555555555555555555555555555555555555555555555555999999999999999999555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555599999999999999995555555555555555aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa99999999999999aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb999999999999bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb9999999999bbbbbbbbbbbbbbbbbbbcccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccccc",
	},
	{
		name: "aquarium",
		file: "aquarium-48.png",
		width: 48,
		height: 48,
		colors: [
			"a374dcff",
			"22172bff",
			"d6eef8ff",
			"aef0f5ff",
			"ffffffff",
			"8fd8f0ff",
			"f76b15ff",
			"ffa64dff",
			"3fcf8eff",
			"6abce8ff",
			"ffd23cff",
			"fff27aff",
			"d6409fff",
			"f2a8f2ff",
			"86d04eff",
			"4f9ad8ff",
			"e6d0a0ff",
		],
		pixels:
			"00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000011111111111111111111111111111111111100000000000122222222222222222222222222222222222210000000000122222222222222222222222222222222222210000000000011113333333333334433333333333333111100000000000000133333333333334433333333333333310000000000000001333333333333333333333333333333331000000000000013333333333333344333333333333333333100000000000133333333333333344333333333333333333310000000000133333333333333333333333333344333333310000000001333333333333333333333333333344333333331000000001333333333333333333333333333333333333331000000015555555555555566665555575555445555555555100000015555555555556666666655775555445555555555100000015555555555556166666657775555555555555555100000155555555555556666666657775555555555555555510000155555555555556666666655775555555555555555510000155555555555555566665555575555555555555555510000155555555555555555555555555555555555555555510000155555555555555555555555555555555555555555510000155555885555555555555555555555555555555555510000199999889999999999999999999aaaa99999b999999100001999998899999999999999999aaaaaaaa99bb9999991000001999988899cccc99999d9999a1aaaaaa8bbb99999100000019999988cccccccc99dd9999aaaaaaaa8bbb99999100000019999988c1cccccc9ddd9999aaaaaaaa88bb99999100000001999998cccccccc9ddd999999aaaa99889b99991000000001999998cccccccc99dd9999999999998899ee99100000000019998889cccc99999d999999999998889eee91000000000019998899ee99999999999999999998899ee991000000000001f888feeeffffffffffffffffff888feeef10000000000000188ffeefffffffffffffffffff88ffeef100000000000000188ffeefffffffffffffffffff88ffee1000000000000000188ggeeggggggggggggggggggg88ggee100000000000000001111gggggggggggggggggggggggg11100000000000000000000011gggggggggggggggggggg110000000000000000000000000011gggggggggggggggg11000000000000000000000000000000111gggggggggg1110000000000000000000000000000000000011111111110000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
	},
	{
		name: "mountains",
		file: "mountains-64.png",
		width: 64,
		height: 64,
		colors: [
			"6ab7ffff",
			"fff27aff",
			"f4f6faff",
			"8fd0ffff",
			"8f9aacff",
			"b7bfccff",
			"b8e2ffff",
			"cfeeffff",
			"3fa04aff",
			"86b4e0ff",
			"7aa8d8ff",
			"7a4a2aff",
			"4c9a3cff",
			"3e9cf0ff",
			"2e7cd0ff",
		],
		pixels:
			"00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000111100000000000000000000222222222222000000000000000000000000001111111100000000000000000222222222222222220000000000000220000000111111110000000000000000022222222222222222200000000000222200000111111111100000000000000000222222222222222220000000000222222000011111111110000000003333333333333333222222223333333333222222223331111111111333333333333333333333333333333333333333333234222552222211111111133333333333333333333333333333333333333333324442555522222111111133333333333333333333333223333333333333333322444455555222211111113333333333333333333333222233333333333333332444445555522233111133333333333333333333333222222333333333333333444444555555333333333333333333333333333333222222223333333333333344444455555553333333333333333333333333333244222552233333333333344444445555555333333332233333333333333333334442555533333333333334444444555555553333332222333333333333333334444455555333333333334444444455555555533332222223333333666666666444445555566666666664444444445555555556662222222266666666666666444444555555666666666444444444555555555562642225522666666666666444444455555556666666444444444455555555555644425555666666666666644444445555555666666644444444445555555555564444555556666666666644444444555555556666644444444444555555555554444455555566666666644444444455555555566664444444444455555555554444445555556666666664444444445555555556664444444444445555555555444444555555566666664444444444555555555564444444444444555555555444444455555555666664444444444455555555555444444444444455555555544444445555555566666444444444445555555555444444444444445555555544444444555555555677444444444444555555555544444444444444555555554444444455555555557444444444444455555555544444444444444455555554444444445555555555744884448844445555555544444444444444445555554444444444588555885544488444884444555555554444444444444444555555444444444458855588554448844488444455555554444444444444444455555444444444445885558855444884448844445555555444444444444444445555544444444444588555885544888848888444555555444444444444444444555544444444444488885888854488884888844455555444444444444444444455544444444444448888588885448888488884445555544444444444444444445554444444444444888858888544888848888444555544444444444444444444554444444444444488885888859988889888899999999999999999999999999999999999999999998888988889a88888888888aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa888888888889988889888899999999999999999999999999999999999999999998888988889a88888888888aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa8888888888898888888888899999999999999999999999999999999999999999888888888888888888888888aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa888888888888999bb999bb999999999999999999999999999999999999999999999bb999bb990aabbaaabbaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaabbaaabbaa099bb999bb999999999999999999999999999999999999999999999bb999bb99ccccccccccccccccaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaacccccccccccccccccccccccccccccc9999999999999999999999999999999999ccccccccccccccccccccccccccccccaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaccccccccccccccdddd99999999999999999999d9999999999999999999999999999999999999dddddddaaaaaaaaaaaaaaaaaadddaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaadddddddd999999999999999999dddd999999999999999999999999999999999ddddddddddaaaaaaaaaaaaaaaadddddaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaddddddddddd99999999999999ddddddd999999999999999999999d999999999ddddddddddddaaaaaaaaaaaaaadddddddaaaaaaaaaaaaaaaaaaaaadaaaaaaaaddddddeeeeeeee999999999999eeeeeeeee9999999999999999999eee9999999eeeeeeeeeeeeeeeaaaaaaaaaaeeeeeeeeeeaaaaaaaaaaaaaaaaaaeeeeaaaaaaeeeeeeeeeeeeeeee9999999999eeeeeeeeeee99999999999999999eeeee9999eeeeeeeeeeeeeeeeeeaaaaaaaaeeeeeeeeeeeeeaaaaaaaaaaaaaaaeeeeeeeaaaeeeeeeeeeeeeeeeeee99999999eeeeeeeeeeeee99999999999999eeeeeeee99eeeeeeeeeeeeeeeeeeeeaaaaaaeeeeeeeeeeeeeeeaaaaaaaaaaaaaeeeeeeeeeeeeeeeeeee",
	},
	{
		name: "city",
		file: "city-64.png",
		width: 64,
		height: 64,
		colors: [
			"8b93ffff",
			"ffffffff",
			"fff6e0ff",
			"e8443cff",
			"b7bfccff",
			"a8a0f0ff",
			"7280b4ff",
			"ffd27aff",
			"3d4570ff",
			"6a7aacff",
			"c890b8ff",
			"5a6a9aff",
			"4f5f90ff",
			"2e3450ff",
		],
		pixels:
			"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",
	},
	{
		name: "butterfly",
		file: "butterfly-64.png",
		width: 64,
		height: 64,
		colors: [
			"3fcf8eff",
			"22172bff",
			"7a4a2aff",
			"f76b15ff",
			"ffffffff",
			"ffa64dff",
			"fff27aff",
			"d6409fff",
			"f2a8f2ff",
		],
		pixels:
			"0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000100000000000000000000000000000000000000000000000121000000000000121000000000000000000000000000000000000000000000122210000000000122210000000000000000000000000000000000000000000001221000000000001210000000000000000000000000000000000000000000000011210000000001210000000000000000000000000000000000000011111100000012100000001210000011111100000000000000000000000001113333331110000121000001210001113333331110000000000000000000001333333333333100001210001210001333333333333100000000000000000001334433333333331000121000121001333333333344331000000000000000001333443333333333310001211121001333333333334433310000000000000001333333333333333333100122221001333333333333333333100000000000001333333355555533333331122222211333333355555533333331000000000001344333555555555533333312222221333333555555555533344310000000000134443555555555555333331222222133333555555555555344431000000000133343555555555555553333322222233333555555555555553433310000000013333355555555555555333331222213333355555555555555333331000000001333355555555555555553333112211333355555555555555553333100000001333335555555665555555333331221333335555555665555555333331000000134435555556666665555553333222233335555556666665555553443100000013443555555666666555555333322223333555555666666555555344310000001344355555666666665555533332222333355555666666665555534431000000133335555566666666555553333222233335555566666666555553333100000013333555555666666555555333322223333555555666666555555333310000001333355555566666655555533332222333355555566666655555533331000000133333555555566555555533333222233333555555566555555533333100000001344355555555555555553333122221333355555555555555553443100000000134433555555555555553333312222133333555555555555553344310000000013443355555555555555333331222213333355555555555555334431000000000133333555555555555333331122221133333555555555555333331000000000013333335555555555333333112222113333335555555555333333100000000000133333335555553333333101222210133333335555553333333100000000000001333333333333333333100122221001333333333333333333100000000000000013333333337777773100012222100013777777333333333100000000000000000133333377777777771001222210017777777777333333100000000000000000001333377777777777710122221017777777777773333100000000000000000000011177777777777777112222117777777777777711100000000000000000000000017777888888777711222211777788888877771000000000000000000000000017777888888887777122221777788888888777710000000000000000000000001777888888888877712222177788888888887771000000000000000000000001777788888888887777222277778888888888777710000000000000000000000177788888888888877722227778888888888887771000000000000000000000017778888444488887772222777888844448888777100000000000000000000001777888844448888777222277788884444888877710000000000000000000000177788884444888877722227778888444488887771000000000000000000000017778888444488887772222777888844448888777100000000000000000000001777888888888888777222277788888888888877710000000000000000000000177778888888888777712217777888888888877771000000000000000000000001777888888888877711221177788888888887771000000000000000000000000177778888888877771122117777888888887777100000000000000000000000001777788888877771012210177778888887777100000000000000000000000000177777777777777100110017777777777777710000000000000000000000000001777777777777100000000177777777777710000000000000000000000000000017777777777100000000001777777777710000000000000000000000000000000117777771100000000000011777777110000000000000000000000000000000000111111000000000000000011111100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
	},
];
